import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { Marker } from "../../common/Marker";
import { StyledWrapper } from "../../RankingWidget/WidgetChart/Legend/styles";
import { TooltipValue } from "../SamTamChart/ChartTooltipContent/styles";

type LegendSchema = {
    primaryEntityName: string;
};

const Legend = ({ primaryEntityName }: LegendSchema) => (
    <Flex margin="0 16px">
        <StyledWrapper>
            <Marker backgroundColor={colorsPalettes.blue[200]} />
            <TooltipValue>{translate("bt.metrics.audienceReach.chart.legend.market")}</TooltipValue>
        </StyledWrapper>
        <StyledWrapper>
            <Marker backgroundColor={colorsPalettes.blue[500]} />
            <TooltipValue>{primaryEntityName}</TooltipValue>
        </StyledWrapper>
    </Flex>
);

export default Legend;
